(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.neuroApi = {}));
})(this, function (exports) {
  'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var CONTENT_DISPOSITION_ATTACHMENT = 'attachment';

  var FetchOptionsBuilder =
  /*#__PURE__*/
  function () {
    function FetchOptionsBuilder() {
      _classCallCheck(this, FetchOptionsBuilder);

      this.charset = 'utf-8';
      this.method = 'GET';
      this.headers = null;
      this.contentType = null;
      this.contentDisposition = null;
      this.credentials = null;
    }

    _createClass(FetchOptionsBuilder, [{
      key: "get",
      value: function get() {
        this.method = 'GET';
        return this;
      }
    }, {
      key: "post",
      value: function post() {
        this.method = 'POST';
        return this;
      }
    }, {
      key: "put",
      value: function put() {
        this.method = 'PUT';
        return this;
      }
    }, {
      key: "delete",
      value: function _delete() {
        this.method = 'DELETE';
        return this;
      }
    }, {
      key: "json",
      value: function json() {
        this.contentType = 'application/json';
        return this;
      }
    }, {
      key: "html",
      value: function html() {
        this.contentType = 'text/html';
        return this;
      }
    }, {
      key: "text",
      value: function text() {
        this.contentType = 'text/plain';
        return this;
      }
    }, {
      key: "noContentType",
      value: function noContentType() {
        this.contentType = null;
        return this;
      }
    }, {
      key: "sameOriginCredentials",
      value: function sameOriginCredentials() {
        this.credentials = 'same-origin';
        return this;
      }
    }, {
      key: "credentials",
      value: function credentials(creds) {
        this.credentials = creds;
        return this;
      }
    }, {
      key: "dispositionAttachement",
      value: function dispositionAttachement(fileName) {
        this.contentDisposition = {
          disposition: 'attachment',
          fileName: fileName
        };
        return this;
      }
    }, {
      key: "header",
      value: function header(name, value) {
        var headers = this.headers || {};

        if (name && value !== undefined) {
          headers[name] = value;
        }

        this.headers = headers;
        return this;
      }
    }, {
      key: "body",
      value: function body(bodyContent) {
        this.bodyContent = bodyContent;
        return this;
      }
    }, {
      key: "build",
      value: function build() {
        var opts = {
          method: this.method
        }; // headers

        var headers = _objectSpread2({}, this.headers || {});

        if (this.contentType) {
          headers['Content-Type'] = this.contentType;
        }

        if (this.contentDisposition) {
          switch (this.contentDisposition.disposition) {
            case CONTENT_DISPOSITION_ATTACHMENT:
              headers['Content-Disposition'] = this.contentDisposition.fileName ? "".concat(CONTENT_DISPOSITION_ATTACHMENT, "; filename=\"").concat(this.contentDisposition.fileName, "\"") : CONTENT_DISPOSITION_ATTACHMENT;
              break;

            default:
              break;
          }
        }

        opts.headers = headers;

        if (this.credentials) {
          opts.credentials = this.credentials;
        }

        if (this.bodyContent !== undefined && this.bodyContent !== null) {
          switch (_typeof(this.bodyContent)) {
            case 'object':
              opts.body = JSON.stringify(this.bodyContent);
              break;

            default:
              opts.body = this.bodyContent;
              break;
          }
        }

        return opts;
      }
    }]);

    return FetchOptionsBuilder;
  }();

  var X_REQUESTED_WITH = 'X-Requested-With';
  var XML_HTTP_REQUEST = 'XMLHttpRequest';
  var CONTENT_TYPE = {
    TEXT_PLAIN: 'text/plain',
    APPLICATION_JSON: 'application/json'
  };
  /**
   * If returned content type is application/json parses the JSON returned by a network request.
   * Returns response text otherwise.
   *
   * @param  {object} response A response from a network request
   *
   * @return {object}          The parsed JSON from the request
   */

  function parseJSON(response) {
    var responseType = response.headers.get('Content-Type');
    var isJSONResponse = (responseType && responseType.indexOf(CONTENT_TYPE.APPLICATION_JSON)) >= 0;

    if (response.status === 204 || response.status === 205) {
      return null;
    }

    return isJSONResponse ? response.json() : response.text();
  }
  /**
   * Checks if a network request came back fine, and throws an error if not
   *
   * @param  {object} response   A response from a network request
   *
   * @return {object|undefined} Returns either the response, or throws an error
   */


  function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }

    var error = new Error("".concat(response.status, " ").concat(response.statusText));
    error.response = response;
    throw error;
  }
  /**
   * Checks if provided content should be sent as JSON
   *
   * @param  {any} body             A request body
   * @param  {string} contentType   A HTTP content-type header value eg. 'application/json'
   *
   * @return {true|false} Returns true when contentType === 'application/json' or body is object and contentType is not defined
   */


  function isJSONContent(body, contentType) {
    var result = false;

    if (!contentType) {
      result = _typeof(body) === 'object';
    } else {
      result = contentType === CONTENT_TYPE.APPLICATION_JSON;
    }

    return result;
  }
  /**
   * Return body normalized to valid JSON format based on it's type
   *
   * @param  {any} body   A request body
   *
   * @return {any} Returns valid JSON body, eg. adds "" when body is string and is not enclosed with ""
   */


  function jsonizeBody(body) {
    var jsonBody = body;

    if (body && typeof body === 'string' && !(body.startsWith('"') && body.endsWith('"'))) {
      jsonBody = "\"".concat(body.replace(/"/g, '\\"'), "\"");
    }

    return jsonBody;
  }
  /**
   * Requests a URL, returning a promise
   *
   * @param  {string} url       The URL we want to request
   * @param  {object} [options] The options we want to pass to "fetch"
   *
   * @return {object}           The response data
   */


  function request(url, options) {
    return fetch(url, options).then(checkStatus).then(parseJSON);
  }
  /**
   * Requests a URL, returning a promise
   *
   * @param  {string} url       The URL we want to get
   *
   * @return {object}           The response data
   */


  function get(url, options) {
    var internalOpts = new FetchOptionsBuilder().get().sameOriginCredentials().header(X_REQUESTED_WITH, XML_HTTP_REQUEST).build();
    var opts = options ? _objectSpread2({}, internalOpts, {}, options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }
  /**
   * Requests a URL, returning a promise
   *
   * @param  {string} url       The URL we want to get
   *
   * @param  {string} fileName  The name of downloaded file
   *
   * @return {object}           The response data
   */


  function download(url, fileName, options) {
    var internalOpts = new FetchOptionsBuilder().get().sameOriginCredentials().header(X_REQUESTED_WITH, XML_HTTP_REQUEST).dispositionAttachement(fileName).build();
    var opts = options ? _objectSpread2({}, internalOpts, {}, options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }
  /**
   * Sends provided data with POST method to url
   *
   * @param  {string} url          The URL we want to post
   * @param  {object|string} body  sends json if body is of type object or plain text when body is string
   *
   * @return {object}           The response data
   */


  function post(url, body, contentType, options) {
    var isJSON = isJSONContent(body, contentType);
    var builder = new FetchOptionsBuilder().post().body(isJSON ? jsonizeBody(body) : body).header(X_REQUESTED_WITH, XML_HTTP_REQUEST).sameOriginCredentials();
    var internalOpts = isJSON ? builder.json().build() : builder.text().build();
    var opts = options ? _objectSpread2({}, internalOpts, {}, options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }
  /**
   * Sends provided data with PUT method to url
   *
   * @param  {string} url          The URL we want to put
   * @param  {object|string} body  sends json if body is of type object or plain text when body is string
   *
   * @return {object}           The response data
   */


  function put(url, body, contentType, options) {
    var isJSON = isJSONContent(body, contentType);
    var builder = new FetchOptionsBuilder().put().body(isJSON ? jsonizeBody(body) : body).header(X_REQUESTED_WITH, XML_HTTP_REQUEST).sameOriginCredentials();
    var internalOpts = isJSON ? builder.json().build() : builder.text().build();
    var opts = options ? _objectSpread2({}, internalOpts, {}, options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }
  /**
   * Sends DELETE request to url
   *
   * @param  {string} url       The URL we want to 'DELETE'
   *
   * @return {object}           The response data
   */


  function del(url, options) {
    var internalOpts = new FetchOptionsBuilder().delete().sameOriginCredentials().header(X_REQUESTED_WITH, XML_HTTP_REQUEST).build();
    var opts = options ? _objectSpread2({}, internalOpts, {}, options) : internalOpts;
    return fetch(url, opts).then(checkStatus).then(parseJSON);
  }
  /**
   * Creates new General API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @returns {object} new GeneralAPI object
   */


  var createGeneralAPI = function createGeneralAPI(baseApiUrl) {
    var GENERAL_URL = "".concat(baseApiUrl);
    /**
     * General API client
     * @typedef {Object} GeneralAPI
     */

    return {
      /**
       * @memberof GeneralAPI
       * @returns {Object} Promise to general info object
       */
      info: function info() {
        return get("".concat(GENERAL_URL, "/info"));
      },

      /**
       * Retrieves whole status object, or it's selected element
       * @memberof GeneralAPI
       * @param {string[]} path - path of the object property to get, eg. ['foo', 'bar', 'baz'] for property 'foo.bar.baz'. If path is not specified, whole object will be returned.
       * @returns {Object} Promise to status object
       */
      status: function status(path) {
        var url = ["".concat(GENERAL_URL, "/status"), path].filter(function (e) {
          return e;
        }).join('/');
        return get(url);
      }
    };
  };

  var createSessions = function createSessions(accessApiUrl) {
    var SESSIONS_URL = "".concat(accessApiUrl, "/sessions/");

    var createSession = function createSession(account, password) {
      return post(SESSIONS_URL, {
        account: account,
        password: password
      });
    };

    var deleteSession = function deleteSession() {
      var sid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return del(sid ? "".concat(SESSIONS_URL).concat(sid) : SESSIONS_URL);
    };

    var sessions = {
      SESSIONS_URL: SESSIONS_URL,

      /**
       * Starts new user session with provided credentials.
       * @memberof AccessAPI.sessions
       * @returns {Promise} A promise to empty response, resolved on success and rejected on any HTTP or network error
       */
      create: createSession,

      /**
       * Same as `create`. Starts new user session with provided credentials.
       * @memberof AccessAPI.sessions
       * @returns {Promise} A promise to empty response, resolved on success and rejected on any HTTP or network error
       */
      login: createSession,

      /**
       * Ends session with given `sid`. If `sid` is not provided current session is ended.
       * @memberof AccessAPI.sessions
       * @param {string} [sid] - id of the session to end
       * @returns {Promise} A promise to empty response, resolved on success and rejected on any HTTP or network error
       */
      remove: deleteSession,

      /**
       * Same as `remove`.
       * @memberof AccessAPI.sessions
       * @param {string} [sid] - id of the session to end
       * @returns {Promise} A promise to empty response, resolved on success and rejected on any HTTP or network error
       */
      logout: deleteSession,

      /**
       * Gets information about session with given `id`. If `id` is not provided current session info is returned.
       * @memberof AccessAPI.sessions
       * @param {string} [sid] - id of the session to get; defaults to `'current'`
       * @returns {Promise<Object>} A promise to session object as described in API documentation for `GET /api/access/sessions/<sid>` endpoint
       */
      get: function get$1() {
        var sid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'current';
        return get("".concat(SESSIONS_URL).concat(sid));
      }
    };
    return sessions;
  }; // ACCOUNT SETTINGS


  var createSettings = function createSettings(accessApiUrl) {
    return {
      SETTINGS_URL: "".concat(accessApiUrl, "/settings/"),

      /**
       * Retrieves value of given user setting. If setting name is not provided object with all user settings is returned.
       * @memberof AccessAPI.settings
       * @param {string} settingName - name of the setting to get
       * @returns {Promise<any>} A promise to object with all user settings, or to single setting value if it's name has been specified. Returned value may be of any valid JSON type.
       */
      get: function get$1(settingName) {
        return get(settingName ? "".concat(this.SETTINGS_URL).concat(settingName) : "".concat(this.SETTINGS_URL));
      },

      /**
       * Sets value of given setting.
       * @memberof AccessAPI.settings
       * @param {string} name - name of the setting to set
       * @param {any} value - value of the setting to store under `name`. Accepts all valid JSON types.
       * @returns {Promise} A promise to empty response
       */
      set: function set(name, value) {
        return name ? post("".concat(this.SETTINGS_URL).concat(name), value, CONTENT_TYPE.APPLICATION_JSON) : null;
      },

      /**
       * Deleted setting with given name. Removes it from database.
       * @memberof AccessAPI.settings
       * @param {string} name - name of the setting to remove
       * @returns {Promise} A promise to empty response
       */
      unset: function unset(name) {
        return name ? del("".concat(this.SETTINGS_URL).concat(name)) : null;
      }
    };
  }; // ACCOUNTS


  var createAccounts = function createAccounts(accessApiUrl) {
    return {
      ACCOUNTS_URL: "".concat(accessApiUrl, "/accounts/"),

      /**
       * Gets list of user account names
       *
       * API call: `/api/access/accounts`
       * @memberof AccessAPI.accounts
       * @returns {Promise<string[]>} A promise to list of account names.
       */
      list: function list() {
        return get(this.ACCOUNTS_URL);
      },

      /**
       * Retrieves information about given user account
       * @memberof AccessAPI.accounts
       * @param {string} accountName
       * @returns {Promise<Object>} A promise to account object as described in API documentation for `GET /api/access/accounts/<accountName>` endpoint
       */
      get: function get$1(accountName) {
        return get("".concat(this.ACCOUNTS_URL).concat(accountName));
      },

      /**
       * Creates new user account
       * @memberof AccessAPI.accounts
       * @param {Object} account - user account object as described in API documentation
       * @returns {Promise} A promise to empty response.
       */
      create: function create(account) {
        return post(this.ACCOUNTS_URL, account);
      },

      /**
       * Modifies new user account
       * @memberof AccessAPI.accounts
       * @param {string} accountName - name of the account to update
       * @param {Object} updater - user account object with new values
       * @returns {Promise} A promise to empty response.
       */
      update: function update(accountName, updater) {
        return put("".concat(this.ACCOUNTS_URL).concat(accountName), updater);
      },

      /**
       * Deletes user account with given name
       * @memberof AccessAPI.accounts
       * @param {string} accountName - name of the account to delete
       * @returns {Promise} A promise to empty response
       */
      delete: function _delete(accountName) {
        return del("".concat(this.ACCOUNTS_URL).concat(accountName));
      }
    };
  }; // GROUPS


  var createGroups = function createGroups(accessApiUrl) {
    return {
      GROUPS_URL: "".concat(accessApiUrl, "/groups/"),

      /**
       * Gets list of permission group names
       *
       * @memberof AccessAPI.groups
       * @returns {Promise<string[]>} A promise to list of group names.
       */
      list: function list() {
        return get(this.GROUPS_URL);
      },

      /**
       * Retrieves information about given permission group
       * @memberof AccessAPI.groups
       * @param {string} groupName
       * @returns {Promise<Object>} A promise to group object as described in API documentation for `GET /api/access/groups/<groupName>` endpoint
       */
      get: function get$1(groupName) {
        return get("".concat(this.GROUPS_URL).concat(groupName));
      },

      /**
       * Creates new permission group
       * @memberof AccessAPI.groups
       * @param {Object} group - permission group object as described in API documentation
       * @returns {Promise} A promise to empty response.
       */
      create: function create(group) {
        return post(this.GROUPS_URL, group);
      },

      /**
       * Modifies new permission group
       * @memberof AccessAPI.groups
       * @param {string} groupName - name of the group to update
       * @param {Object} updater - permission group object with new values
       * @returns {Promise} A promise to empty response.
       */
      update: function update(groupName, updater) {
        return put("".concat(this.GROUPS_URL).concat(groupName), updater);
      }
    };
  }; // PERMISSIONS


  var createPermissions = function createPermissions(accessApiUrl) {
    return {
      PERMISSIONS_URL: "".concat(accessApiUrl, "/permissions/"),

      /**
       * Gets list of all API permission names
       * @memberof AccessAPI.permissions
       * @returns {Promise<string[]>} A promise to list of permission names.
       */
      list: function list() {
        return get(this.PERMISSIONS_URL);
      },

      /**
       * Gets details about single permission
       * @memberof AccessAPI.permissions
       * @param {string} permissionName
       * @returns {Promise<Object>} A promise to permission details.
       */
      get: function get$1(permissionName) {
        return get("".concat(this.PERMISSIONS_URL).concat(permissionName));
      }
    };
  };
  /**
   * Creates new Access API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @returns {object} new AccessAPI object
   */


  var createAccessAPI = function createAccessAPI(baseApiUrl) {
    var ACCESS_URL = "".concat(baseApiUrl, "/access");
    /**
     * Access API client (`/api/access/*` endpoints)
     * @typedef {Object} AccessAPI
     * @property {Object} sessions - functions of Sessions module of AccessAPI
     * @property {Object} accounts - functions of Accounts module of AccessAPI
     * @property {Object} settings - functions of Account Settings module of AccessAPI
     * @property {Object} groups - functions of Groups module of AccessAPI
     * @property {Object} permissions - functions of Permissions module of AccessAPI
     */

    return {
      /**
       * @memberof AccessAPI
       */
      sessions: createSessions(ACCESS_URL),

      /**
       * @memberof AccessAPI
       */
      accounts: createAccounts(ACCESS_URL),

      /**
       * @memberof AccessAPI
       */
      settings: createSettings(ACCESS_URL),

      /**
       * @memberof AccessAPI
       */
      groups: createGroups(ACCESS_URL),

      /**
       * @memberof AccessAPI
       */
      permissions: createPermissions(ACCESS_URL)
    };
  };

  var createEvents = function createEvents(storageApiUrl) {
    return {
      EVENTS_URL: "".concat(storageApiUrl, "/events"),

      /**
       * Makes GET request to `/api/storage/events` endpoint
       * @memberof StorageAPI.events
       * @returns {Promise<string[]>} A promise to list of available event types (strings)
       * @example
       * storageAPI.events.types().then((result) => console.log(result.data))
       * // ['VehicleTrace', 'Status']
       */
      types: function types() {
        var result = null;
        result = get(this.EVENTS_URL);
        return result;
      },

      /**
       * Makes GET request to `/api/storage/events/<eventId>/<eventResourcePath>` endpoint
       * @memberof StorageAPI.events
       * @param {string} id - id of the event to get
       * @param {string} [resourcePath] - resource path
       * @returns {Promise<Object>} A promise to event object or event resource (if `resourcePath` param is provided)
       */
      get: function get$1(id, resourcePath) {
        var asDownload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var detailsUrl = "".concat(this.EVENTS_URL, "/").concat(id);
        var url = resourcePath ? "".concat(detailsUrl, "/").concat(resourcePath) : detailsUrl;
        return asDownload ? download(url, resourcePath) : get(url);
      },

      /**
       * Returns base event URL i.e. `http://example.com/api/storage/events/<eventId>`
       * @memberof StorageAPI.events
       * @param {string} id - id of the event URL is returned to
       * @returns {string} full event URL
       */
      baseUrl: function baseUrl(id) {
        return "".concat(this.EVENTS_URL, "/").concat(id);
      },

      /**
       * Returns URL to event's resource i.e. `http://example.com/api/storage/events/<eventId>/<resourcePath>`
       * @memberof StorageAPI.events
       * @param {string} id - id of the event URL is returned to
       * @param {string} resourceName - name of the resource URL is returned to
       * @returns {string} full event resource URL
       */
      resourceUrl: function resourceUrl(id, resourceName) {
        return "".concat(this.baseUrl(id), "/").concat(resourceName);
      }
    };
  };

  var createSearch = function createSearch(storageApiUrl) {
    return {
      SEARCH_URL: "".concat(storageApiUrl, "/search"),

      /**
       * Makes GET request to `/api/storage/search` endpoint
       * @memberof StorageAPI.search
       * @returns {Promise<SearchSchema>}
       */
      schema: function schema() {
        return get(this.SEARCH_URL);
      },

      /**
       * Performs search on event database. Makes GET request to `/api/storage/search/<EventType>?...` endpoint
       * @memberof StorageAPI.search
       * @param {string} type - type of the events to search
       * @param {string[]} [fields] - names of fields to return for each event
       * @param {string[]} [conditions]
       * @param {number} [from] - index of the first returned result (0-based)
       * @param {number} [count] - number of records to return
       * @param {string[]} [order]
       * @param {Object} [reqOptions]
       * @returns {Promise<string[]|Object[]>} if `fields` param is not defined returns array of event ids (strings) and array of objects otherwise.
       */
      results: function results(type, fields, conditions) {
        var from = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var count = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
        var order = arguments.length > 5 ? arguments[5] : undefined;
        var reqOptions = arguments.length > 6 ? arguments[6] : undefined;
        var conditionsPath = conditions && conditions.length > 0 ? conditions.map(function (c) {
          return encodeURIComponent(c);
        }).join('/') : null;
        var searchUrl = conditionsPath ? "".concat(this.SEARCH_URL, "/").concat(type, "/").concat(conditionsPath) : "".concat(this.SEARCH_URL, "/").concat(type);
        var queryString = ["from=".concat(from), "count=".concat(count), fields && fields.length > 0 ? "fields=".concat(fields.join(',')) : null, order && order.length > 0 ? "order=".concat(order.join(',')) : null].filter(function (e) {
          return e;
        }).join('&');
        return get(queryString ? "".concat(searchUrl, "?").concat(queryString) : searchUrl, reqOptions);
      }
    };
  };
  /**
   * Creates new Storage API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @returns {object} new StorageAPI object
   */


  var createStorageAPI = function createStorageAPI(baseApiUrl) {
    var STORAGE_URL = "".concat(baseApiUrl, "/storage");
    /**
     * Storage API client (`/api/storage/*` endpoints)
     * @typedef {Object} StorageAPI
     * @property {Object} events - functions of Events module of StorageAPI
     * @property {Object} search - functions of Search module of StorageAPI
     */

    return {
      /**
       * @memberof StorageAPI
       */
      events: createEvents(STORAGE_URL),

      /**
       * @memberof StorageAPI
       */
      search: createSearch(STORAGE_URL)
    };
  };
  /**
   * SearchSchema - object describing available search fields and their types.
   * This object has following shape:
   * ```js
   * {
   *   <EventType1>: {
   *     fieldName1: {SearchFieldType},
   *     fieldName2: {SearchFieldType},
   *     ...
   *   },
   *   <EventType2>: {...},
   * }
   * ```
   * @typedef SearchSchema
   * @type {Object}
   */

  /**
   * SearchFieldType - string describing type of given search field. It is one of the following values: 'TEXT', 'REAL', 'INTEGER'
   * @typedef SearchFieldType
   * @type {string}
   */

  /**
   * Events
   * @typedef Events
   * @type {(string[]|Object[])}
   */


  var createRecords = function createRecords(registerApiUrl) {
    return {
      RECORDS_URL: "".concat(registerApiUrl, "/records"),

      /**
       * Gets content (list of records) of the given registry list
       * @memberof RegistryAPI.records
       * @param {string} listName - registry list name to get
       * @returns {Promise<Object[]>} A promise to list of records
       */
      list: function list(listName) {
        if (!listName) {
          throw new TypeError('invalid argument - listName must be defined');
        }

        return get("".concat(this.RECORDS_URL, "/").concat(listName));
      },

      /**
       * Adds new record to given list
       * @memberof RegistryAPI.records
       * @param {string} listName - registry list name record will be added to
       * @param {Object} record - registry list record to add
       * @returns {Promise} A promise to empty response
       */
      create: function create(listName, record) {
        return post("".concat(this.RECORDS_URL, "/").concat(listName), record);
      },

      /**
       * Removes record with given id from registry list with given name
       * @memberof RegistryAPI.records
       * @param {string} listName - registry list name record will be deleted from
       * @param {Object} recordId - id of the record to delete
       * @returns {Promise} A promise to empty response
       */
      delete: function _delete(listName, recordId) {
        return del("".concat(this.RECORDS_URL, "/").concat(listName, "/").concat(recordId));
      }
    };
  };
  /**
   * Creates new Register API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @returns {object} new RegisterAPI object
   */


  var createRegisterAPI = function createRegisterAPI(baseApiUrl) {
    var REGISTER_URL = "".concat(baseApiUrl, "/register");
    /**
     * Register API client (`/api/register/*` endpoints)
     * @typedef {Object} RegisterAPI
     */

    return {
      /**
       * Gets description object for registry list with given name. If list name is omitted object describing all defined lists is returned.
       * @memberof RegisterAPI
       * @param {string} listName - name of the registry list to get
       * @returns {Object} object describing all defined regitry lists
       *
       */
      get: function get$1(listName) {
        return get("".concat(REGISTER_URL, "/lists").concat(listName ? "/".concat(listName) : ''));
      },

      /**
       * @memberof RegisterAPI
       */
      records: createRecords(REGISTER_URL)
    };
  };
  /**
   * Creates new Services API client
   * @function
   * @param {string} baseApiUrl - base API url containing `/api` path, eg. `http://example.com/api`
   * @returns {object} new ServicesAPI object
   */


  var createServicesAPI = function createServicesAPI(baseApiUrl) {
    var SERVICES_URL = "".concat(baseApiUrl, "/services");
    /**
     * Services API client (`/api/services/*` endpoints)
     * @typedef {Object} ServicesAPI
     */

    return {
      /**
       * Gets URL to proxied service
       * @memberof ServicesAPI
       * @param {string} serviceName - name of the proxied service
       * @param {string[]} args - array of service arguments passed to request url
       * @returns {string} url to given service
       *
       */
      url: function url(serviceName, args) {
        if (!serviceName) {
          throw new TypeError('invalid argument - serviceName must be defined ');
        }

        var argStr = (args || []).filter(function (e) {
          return e;
        }).join('/');
        return "".concat(SERVICES_URL, "/").concat(serviceName).concat(argStr ? "/".concat(argStr) : '');
      }
    };
  };

  exports.CONTENT_TYPE = CONTENT_TYPE;
  exports.createAccessAPI = createAccessAPI;
  exports.createGeneralAPI = createGeneralAPI;
  exports.createRegisterAPI = createRegisterAPI;
  exports.createServicesAPI = createServicesAPI;
  exports.createStorageAPI = createStorageAPI;
  exports.del = del;
  exports.download = download;
  exports.get = get;
  exports.post = post;
  exports.put = put;
  exports.request = request;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});